import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false,
      isLoading: false,
      desc: '',
      descRules: [
        (v) => !!v || 'Motivo é requerido.',
        (v) => (v && v.length > 3) || 'A descrição deve ser no mínimo 3 caracters'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedClient'
    ]),
    isValid () {
      let result = false

      if (this.desc.length > 3) {
        result = true
      } else {
        result = false
      }

      return result
    },
    isClientEnabled () {
      return !this.getterSelectedClient.enabled
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_CLIENT()
  },
  methods: {
    ...mapActions([
      'actionEnableClient'
    ]),
    ...mapMutations([
      'SET_SELECTED_CLIENT'
    ]),
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    enableClient () {
      const params = {
        client: this.getterSelectedClient,
        idClient: this.getterSelectedClient.idClient,
        desc: this.desc,
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoading = true

      this.actionEnableClient(params)
        .then(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Cliente bloqueado com sucesso',
            type: 'success'
          })

          this.closeModal()
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
